import React, { useEffect, useState } from "react";
import "./App.css";
import SunriseSunset from "./SunriseSunset";
import useBackgroundRotation from './hooks/useBackgroundRotation';

function App() {
  const { currentBackground } = useBackgroundRotation();
  const isInIframe = window.self !== window.top;
  const [isMobile, setIsMobile] = useState(false);

  // Check if the device is mobile
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  React.useEffect(() => {
    // Apply styles based on iframe context
    if (isInIframe) {
      document.body.style.width = '100%';
      document.body.style.maxWidth = '100vw';
      document.body.style.margin = '0';
      document.body.style.padding = '0';
    }

    if (currentBackground) {
      // Apply styles to body
      if (isMobile) {
        // Use grey background for mobile
        document.body.style.backgroundImage = 'none';
        document.body.style.backgroundColor = '#ffffff';
      } else {
        // Use background image for larger screens
        document.body.style.backgroundImage = `url(${currentBackground})`;
        document.body.style.backgroundSize = 'cover';
        document.body.style.backgroundPosition = 'center';
      }
      
      document.body.style.backgroundAttachment = 'fixed';
      document.body.style.minHeight = '100vh';
      document.body.style.margin = '0';
      document.body.style.padding = '0';
      
      // Add a semi-transparent overlay for better readability (only for non-mobile)
      if (!isMobile) {
        const overlay = document.createElement('div');
        overlay.id = 'background-overlay';
        overlay.style.position = 'fixed';
        overlay.style.top = '0';
        overlay.style.left = '0';
        overlay.style.width = '100%';
        overlay.style.height = '100%';
        overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.2)';
        overlay.style.zIndex = '-1';
        
        // Remove existing overlay if any
        const existingOverlay = document.getElementById('background-overlay');
        if (existingOverlay) {
          document.body.removeChild(existingOverlay);
        }
        
        document.body.appendChild(overlay);
      }
    }
    
    return () => {
      document.body.style.backgroundImage = '';
      document.body.style.backgroundColor = '';
      
      // Remove the overlay
      const overlay = document.getElementById('background-overlay');
      if (overlay) {
        document.body.removeChild(overlay);
      }
    };
  }, [currentBackground, isInIframe, isMobile]);
  
  return (
    <div className={`App ${isInIframe ? 'in-iframe' : ''} ${isMobile ? 'mobile' : ''}`}>
      <header className="App-header">
        <SunriseSunset />
      </header>
    </div>
  );
}

export default App;
